#import "../fragments/email-sequence-template-basic.graphql"

query SalesAutomationableEmailSequenceTemplates($stagesetId: ID) {
    salesAutomationableEmailSequenceTemplates(stagesetId: $stagesetId) {
        ...EmailSequenceTemplateBasic
    }
}
